import coverArtPlaceHolder2 from 'assets/images/play-icon.png';
import useCoverArt from 'hooks/useCoverArt';

const CoverArtImg = ({
  title = '',
  imgUrl = coverArtPlaceHolder2,
  height = '12',
  artist = '',
}) => {
  const { coverArt } = useCoverArt(artist, title);

  return (
    <img
      className={`h-${height} w-auto inline mr-3 rounded`}
      src={coverArt || imgUrl}
      alt=""
    />
  );
};

export default CoverArtImg;
